import React, { Fragment, ReactNode } from 'react';
import { Ball } from '../../../elements';
import DynamicStyle from '../../common/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


type TransferApplicationStepProps = {
  children: ReactNode,
  number: number,
  label: string,
  description: string,
  status: string
}

const TransferApplicationStep = ({ children, label, description, status, number }: TransferApplicationStepProps) => {
  return (
    <Fragment>
      <div className="mb-5">
        <div onClick={() => console.log('he')}>
          <div className="step-header-base bg-silver">
            <Ball bgColor={DynamicStyle.getStatusColor(status)} ballLabel={number} />
            <div className="step-header-border" />
            <div className="step-header-title">
              <h3>{label}</h3>
              <h4>{description}</h4>
            </div>
            <label className="step-header-status">
              <div className="step-status">
                <i className={`fas ${DynamicStyle.getStatusIcon(status)} fa-2x ${DynamicStyle.getStatusColor(status)}`} /><i className=""></i>
                <label className="ml-3 mr-4">{status}</label>
              </div>
            </label>
          </div>
        </div>
        <div className="step-content">
          <div className="step-content-slot">
            {children}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default TransferApplicationStep;
